<template>
  <generic-error no-appbar>
    <template v-slot:title>Erreur interne</template>
    <h1>Erreur interne</h1>
    <p>Désolé, une erreur interne est survenue.</p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
